import React, { FC } from 'react';
import LicenseInfoPage from './license-info';
import { Route, Routes } from 'react-router-dom';
import LicenseListIndex from './license-list-index';

const LicensesIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<LicenseListIndex />} />
      <Route path={`/:id`} element={<LicenseInfoPage />} />
    </Routes>
  );
};

export default LicensesIndex;
